// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import CheckboxGroup, {
    CheckboxGroupPresentationProps,
    CheckboxGroupProps,
} from "@store/MobiusOverrides/CheckboxGroup/CheckboxGroup";
import constants from "@store/constants";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import clearEmptyChild from "@toolkit/Framework/Common/Utilities/react/clearEmptyChild";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import React, { Children, FC } from "react";
import { css } from "styled-components";

const checkboxSize = checkboxSizes.default as any;

export interface CheckboxFieldsetPresentationProps extends ExpandStyles<CheckboxFieldsetStyles> {}

export interface CheckboxFieldsetProps extends CheckboxFieldsetPresentationProps, CheckboxGroupProps {}

export interface CheckboxFieldsetStyles {
    checkboxGroup?: CheckboxGroupPresentationProps;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
}

const checkboxFieldsetFormStyles: CheckboxFieldsetStyles = {
    checkboxGroup: {
        mergeCss: true,
        css: css`
            width: 100%;

            & > ${TypographyStyle}:first-child {
                margin-bottom: ${() => sizeVariantValues.default.descriptionLineSpacing}px;
            }
        `,
    },
    gridContainer: {
        gap: 0,
        css: css`
            ${() => gridGapStyles(pxToRemArray([30]), [`${checkboxSize.itemSpacing}px`])}
            padding: ${pxToRem(18)};
            border: ${constants.formField.borderWidth}px solid ${getColor("common.border")};
            border-radius: ${() => sizeVariantValues.default.borderRadius}px;
        `,
    },
    gridItem: { width: [12, 12, 6, 6, 4] },
};

const CheckboxFieldset: FC<CheckboxFieldsetProps> = ({
    children: baseChildren,
    extendedStyles,
    overridedStyles,
    ...checkboxGroupProps
}) => {
    const styles = useExpandProps(checkboxFieldsetFormStyles, extendedStyles, overridedStyles);
    const children = clearEmptyChild(baseChildren);

    if (!Children.count(children)) {
        return null;
    }

    return (
        <CheckboxGroup as="fieldset" {...styles.checkboxGroup} {...checkboxGroupProps}>
            <GridContainer {...styles.gridContainer}>
                <>{Children.map(children, x => (x ? <GridItem {...styles.gridItem}>{x}</GridItem> : null))}</>
            </GridContainer>
        </CheckboxGroup>
    );
};

export default CheckboxFieldset;
